import { Helmet } from 'react-helmet';
import Button from '../components/ui/Button';

export default function Community() {
  return (
    <main className="section-container py-10 md:py-24">
      <Helmet>
        <title>Our Community | Carter Asset Management</title>
        <meta
          name="description"
          content="How Carter Asset Management supports our local community—events, education, and partnerships."
        />
      </Helmet>
      <header className="mb-8">
        <h1 className="text-2xl md:text-4xl font-semibold tracking-tight text-slate-900">Our Community</h1>
        <p className="mt-2 max-w-2xl text-slate-600">
          We’re proud to support the people and organizations that make our community stronger. Here’s a look at how we show
          up—through events, education, and partnerships.
        </p>
      </header>

      <section className="grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-8">
        <div className="rounded-2xl bg-white p-6 md:p-7 shadow-sm ring-1 ring-slate-200/90">
          <h2 className="text-lg font-semibold text-slate-900 md:text-xl">Events &amp; Workshops</h2>
          <p className="mt-2 text-slate-600">
            Quarterly talks on markets and planning; open office hours; Q&amp;A nights for families and founders.
          </p>
        </div>
        <div className="rounded-2xl bg-white p-6 md:p-7 shadow-sm ring-1 ring-slate-200/90">
          <h2 className="text-lg font-semibold text-slate-900 md:text-xl">Local Partnerships</h2>
          <p className="mt-2 text-slate-600">
            Collaborations with local nonprofits, schools, and veteran groups to advance financial literacy.
          </p>
        </div>
        <div className="rounded-2xl bg-white p-6 md:p-7 shadow-sm ring-1 ring-slate-200/90">
          <h2 className="text-lg font-semibold text-slate-900 md:text-xl">Volunteer &amp; Giving</h2>
          <p className="mt-2 text-slate-600">
            Team volunteer days and sponsorships aligned with our values and client interests.
          </p>
        </div>
        <div className="rounded-2xl bg-white p-6 md:p-7 shadow-sm ring-1 ring-slate-200/90">
          <h2 className="text-lg font-semibold text-slate-900 md:text-xl">Get Involved</h2>
          <p className="mt-2 text-slate-600">
            Have an event or cause we should consider? Reach out—we’d love to hear from you.
          </p>
          <div className="mt-4">
            <Button href="/contact" variant="primary">
              Contact Us
            </Button>
          </div>
        </div>
      </section>
    </main>
  );
}
